/**
 * "Oct 18" — the year only when it is not the current one (Figma annotation
 * `3609:69226`). Invalid or missing dates give an empty string.
 */
export function formatPriceDate(iso: string | null | undefined, locale: string, now = new Date()): string {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  const sameYear = date.getFullYear() === now.getFullYear()
  return date.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    ...(sameYear ? {} : { year: 'numeric' }),
  })
}

/** Same calendar day as `now` (or a clock skew ahead of us) — "updated today". */
export function isPriceDateToday(iso: string | null | undefined, now = new Date()): boolean {
  if (!iso) return false
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return false
  const startOfDay = (value: Date) => new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime()
  return startOfDay(date) >= startOfDay(now)
}
